// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1DnYR","right":"styles_right__LPEd2"};